import { defineComponent as _defineComponent } from 'vue'
import { navigationItems } from "@/config/navigation";
import { computed, getCurrentInstance, onMounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BottomNavigation',
  setup(__props) {

const value = ref("schedules");

const vueInstance = getCurrentInstance();

const currentRoute = computed(() => {
  return vueInstance?.proxy.$route.name ?? "";
});

function onChange(value: { to: { name: string } }) {
  // check current route is same
  if (currentRoute.value === value.to.name) return;
  // navigate to the route
  vueInstance?.proxy.$router.push({ name: value.to.name });
}

function syncCurrentRoute(routeName: string) {
  // set value according to current route
  const relatedRoute = navigationItems.find(
    (item) => item.to.name === routeName,
  );
  if (!relatedRoute) return;
  value.value = relatedRoute.id;
}

watch(currentRoute, (value) => {
  syncCurrentRoute(value);
});

onMounted(() => {
  syncCurrentRoute(currentRoute.value);
});

return { __sfc: true,value, vueInstance, currentRoute, onChange, syncCurrentRoute, navigationItems }
}

})